<ag-grid-angular
  #recordingJobGrid
  [hidden]="showManageJobOverlay"
  class="ag-theme-balham recording-scheduler-grid"
  [columnDefs]="columnDefs"
  (gridReady)="onGridReady($event)"
  [gridOptions]="gridOptions"
  [ngClass]="{ 'hide-pagination': hidePagination }"
></ag-grid-angular>

<evrideo-add-or-edit-recording-job
  *ngIf="showManageJobOverlay"
  [recordingJob]="recordingJobToManage"
  (recordingJobChanged)="saveJobSettings($event)"
>
</evrideo-add-or-edit-recording-job>
